
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomerNew from "@/models/Customer/CustomerNew";
import vToggleSwitch from "@/components/vToggleSwitch.vue";
import { mapState } from "vuex";
import Package from "../models/Subscriptions/SubscriptionPackages/Package";
import SubscriptionRepository from "../utils/API/SubscriptionRepository";

@Component({
  components: {
    vToggleSwitch,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vManageCustomerModal extends Vue {
  @Prop() show!: boolean;
  @Prop() modalTitle!: string;
  @Prop() customer!: CustomerNew;
  @Prop() currentCustomerEnabled!: boolean;
  @Prop() editMode!: boolean;

  passwordMismatch = false;
  disableCustomer = false;

  packages: any[] = [];

  localizationState: any;

  customerSpecialUnlimited: boolean = false;

  subscriptionPackages: Package[] = [];
  subscriptionPackage: Package | null = null;

  @Watch("customerSpecialUnlimited")
  specialSubscriptionEndDate() {
    this.customer.specialSubscriptionEndDate = null;
  }

  @Watch("show")
  showModal() {
    let bodee = document.getElementsByTagName("body")[0];
    if (this.show) bodee.classList.add("modalOpen");
    else bodee.classList.remove("modalOpen");
  }

  hideModal() {
    this.$emit("hideModal");
  }

  cancelModal() {
    this.$emit("cancelModal");
    this.passwordMismatch = false;
  }

  toggleCustomer(value: boolean) {
    this.$emit("toggledCustomer", value);
  }

  submitForm() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        if (this.editMode) {
          this.$emit("submitEdit");
        }
        else {
          if (
            this.isEmailPasswordCustomer &&
            this.customer.ownerPassword !== this.customer.confirmOwnerPassword
          ) {
            this.passwordMismatch = true;
            return;
          }
          this.customer.isSpecial = this.customer.accountType == 1;
          this.passwordMismatch = false;
          this.$emit("submitForm");
        }
        return;
      }
      this.$snotify.error(this.translations.get("validation-error-message"));
    });
  }

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.show && e.keyCode == 27) {
        this.cancelModal();
      }
    });
  }

  created() {
    SubscriptionRepository.displaySubscriptionPackages()
      .then((response) => {
        this.packages = response.data.result;
        if (this.packages.length > 0) {
          this.customer.subscriptionPackageId = this.packages[0].id;
        }
      })
      .catch((error) => {
        if (error.response)
          this.$snotify.error(
            error.response.errorMessages[0].userVisibleMessage
          );
        else this.$snotify.error(this.translations.get("network-error"));
      });
  }

  clearHiddenAuthenticationFields() {
    this.customer.ownerPassword = "";
    this.customer.confirmOwnerPassword = "";
    this.customer.microsoftEntraTenantId = "";
    this.passwordMismatch = false;
  }

  get isEmailPasswordCustomer() {
    return this.customer.signInMethod === this.emailPasswordSignInMethod;
  }

  get isMicrosoftCustomer() {
    return this.customer.signInMethod === this.microsoftSignInMethod;
  }

  emailPasswordSignInMethod = 0;
  googleSignInMethod = 1;
  microsoftSignInMethod = 3;

  get translations() {
    return this.localizationState.translations;
  }
}
